var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 47.089844 47.812407",
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-461.04806,-162.49598)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "59.1948px",
      lineHeight: 1.25,
      fontFamily: "Lato",
      InkscapeFontSpecification: "Lato",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#71c837",
      fillOpacity: 1,
      stroke: "#5aa02c",
      strokeWidth: 2,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    x: 460.02481,
    y: 208.78813,
    id: "text5081"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan5079",
    x: 460.02481,
    y: 208.78813,
    style: {
      fill: "#71c837",
      stroke: "#5aa02c",
      strokeWidth: 2,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  }, "\u2714"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green-tick.62853236f0e147ccda12f86ee7b10e2e.svg";
export { ForwardRef as ReactComponent };